/* GENERATED by tools/write-version.mjs — do not edit by hand.
   Regenerated automatically before dev/build (see package.json). */
export const APP_VERSION = {
  "commit": "b9ae443",
  "branch": "master",
  "dirty": false
};
